import { parseReportDateForSort } from "./reportDateSortUtils";
import { getNextSortConfig } from "./dailySaleReportTableConfig";

export { getNextSortConfig };

export const CASH_REGISTER_REPORT_FIXED_COLUMNS = 5;

export const CASH_REGISTER_COLUMN_FIELDS = [
  null,
  "outlate",
  "cashier",
  "open_date",
  "close_date",
  "timeSpan",
  "open_float",
  "formatted_expected",
  "formatted_counted",
  "formatted_difference",
  "close_float",
  null,
];

const NUMERIC_FIELDS = new Set([
  "open_float",
  "close_float",
]);

const DATE_FIELDS = new Set(["open_date", "close_date"]);

const getSortValue = (row, field) => {
  const value = row?.[field];
  if (value === null || value === undefined || value === "") return null;
  if (DATE_FIELDS.has(field)) return parseReportDateForSort(value);
  if (NUMERIC_FIELDS.has(field)) {
    const num = Number(value);
    return Number.isFinite(num) ? num : null;
  }
  return String(value).toLowerCase();
};

const compareValues = (left, right) => {
  if (left === null && right === null) return 0;
  if (left === null) return 1;
  if (right === null) return -1;
  if (typeof left === "number" && typeof right === "number") {
    return left - right;
  }
  return String(left).localeCompare(String(right), undefined, {
    sensitivity: "base",
    numeric: true,
  });
};

export const sortCashRegisterReportRows = (rows, sortConfig) => {
  if (!Array.isArray(rows) || !rows.length) return rows || [];
  if (!sortConfig?.columnIndex || sortConfig.columnIndex === 0) return rows;

  const field = CASH_REGISTER_COLUMN_FIELDS[sortConfig.columnIndex];
  if (!field) return rows;

  const direction = sortConfig.direction === "desc" ? -1 : 1;

  return [...rows].sort((rowA, rowB) => {
    const comparison = compareValues(
      getSortValue(rowA, field),
      getSortValue(rowB, field)
    );
    return comparison * direction;
  });
};
